// src/components/Contact.js
import React, { useState } from 'react';
import '../App.css';

const HandshakeLogo = () => (
  <svg width="300" height="200" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 20C45 25 40 30 35 35L45 45L55 35C60 30 65 25 70 20" stroke="#2E7D32" strokeWidth="5" />
    <path d="M30 50H70" stroke="#FFB300" strokeWidth="5" />
    <path d="M35 65L50 50L65 65" stroke="#1B5E20" strokeWidth="5" />
  </svg>
);

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`FugiPay Inquiry: ${formData.message.substring(0, 50)}${formData.message.length > 50 ? '...' : ''}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`);
    window.location.href = `mailto:fugiinvestments@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <section className="contact-section">
      <div className="content-wrapper">
        <div className="contact-flex">
          <div className="contact-text">
            <h2 className="section-title">Contact Us</h2>
            <p className="section-description">
              Need a helping hand? We’re here to support you every step of the way.
            </p>
            <div className="contact-image-wrapper">
              <HandshakeLogo />
            </div>
          </div>
          <div className="contact-form-wrapper">
            <form onSubmit={handleSubmit} className="contact-form">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Full Name"
                required
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address"
                required
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows="4"
                required
              ></textarea>
              <button type="submit" className="submit-button">Send Email</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;